<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
        :title="titleItem"
        :small="true"
        :addClose="true"
        @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">
      </dean-notification>

      <dean-text-area id="comment" label="opmerking" v-model="data.comment"
                     :required-field="true"
                      :rows="'3'"
                     :warning="$v.data.comment.$error"></dean-text-area>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import {deanDialogBus} from '@/main';
  import {validationMixin} from 'vuelidate';
  import {required, minLength, maxLength} from 'vuelidate/lib/validators';
  import {Validations} from 'vuelidate-property-decorators';
  import {createNotification} from '@/mixins/validations';
  import DeanTextArea from "@/components/deanComponents/deanTextArea.vue";

  @Component({
    components: {
      DeanTextArea,
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanDialogButtonGroup,
    },
    mixins: [validationMixin],
  })

  export default class AddCommentDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: string,
    };
    public data: { [key: string]: any } = {
      comment: null,
    };
    public titleItem: string = 'Orderregels Opmerking';

    // COMPUTED
    @Validations()
    get validations() {
      return {
        data: {
          comment: {
            required,
            minLength: minLength(5),
            maxLength: maxLength(255),
          },
        },
      };
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);

        let requestAction: string = 'addComment';

        const requestData: any = {
          id: this.payloadData.id,
          data: this.data,
        };

        this.$store.dispatch(requestAction, requestData).then(
          (response) => {
            deanDialogBus.$emit('saved');
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'Orderregels kunnen momenteel niet opgezegd worden',
              theme: 'warning',
            });
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotification(this.$v));
      }
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

:deep(.dialog .dean-dialog-container) {
  width: 500px;
}

</style>
